import { render, staticRenderFns } from "./order_afte_sale_detail.vue?vue&type=template&id=2c3b3563&"
import script from "./order_afte_sale_detail.vue?vue&type=script&lang=js&"
export * from "./order_afte_sale_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_afte_sale_detail.vue?vue&type=style&index=0&id=2c3b3563&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports